"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOnPDPHrefClick = void 0;
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _constants = require("../constants");
var _useOnHrefClick = require("./useOnHrefClick");
const useOnPDPHrefClick = ({
  onClick
}) => {
  const onHashChange = (0, _react.useCallback)(event => {
    const newUrl = new URL(event.newURL);
    const productCode = newUrl.hash.match(_constants.OPEN_VIRTUAL_TRY_ON_PDP_HREF_REGEXP)?.[1];
    if (productCode) {
      onClick();
      window.localStorage.setItem(_constants.PDP_CODE_LOCAL_STORAGE_KEY, productCode);
      (0, _useOnHrefClick.deleteHash)();
    }
  }, [onClick]);
  const events = (0, _react.useMemo)(() => [{
    name: 'hashchange',
    listener: onHashChange
  }], [onHashChange]);
  (0, _presentationHooks.useGlobalEvents)(events);
  (0, _react.useEffect)(() => {
    const onOpen = event => {
      if ((0, _useOnHrefClick.shouldOpen)(_constants.OPEN_VIRTUAL_TRY_ON_PDP_HREF_REGEXP, event.target)) {
        event.preventDefault();
        onClick();
      }
    };
    document.addEventListener('click', onOpen);
    return () => document.removeEventListener('click', onOpen);
  }, [onClick, onHashChange]);
};
exports.useOnPDPHrefClick = useOnPDPHrefClick;
